var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGillRoyMerged(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "royMerged",
    width: "295px",
    height: "234px",
    viewBox: "0 0 295 234",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#27CE0A",
    fillRule: "nonzero",
    cx: 71.5189681,
    cy: 151.42868,
    r: 13.5204856
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval2",
    fill: "#27CE0A",
    fillRule: "nonzero",
    cx: 123.14264,
    cy: 151.42868,
    r: 13.5204856
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.191199,178.059939 C121.913505,176.625948 118.021244,178.059939 116.587253,181.337633 C113.924127,187.073596 106.139605,191.170713 97.3308042,191.170713 C88.522003,191.170713 80.737481,187.073596 78.0743551,181.337633 C76.6403642,178.059939 72.7481032,176.625948 69.4704097,178.059939 C66.1927162,179.49393 64.7587253,183.386191 66.1927162,186.663885 C70.9044006,197.111533 83.400607,204.076631 97.3308042,204.076631 C111.261002,204.076631 123.757208,197.111533 128.468892,186.663885 C129.902883,183.386191 128.468892,179.49393 125.191199,178.059939 Z",
    id: "Path",
    fill: "#27CE0A",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#27CE0A",
    fill: "#27CE0A",
    x: 58.5,
    y: 147,
    width: 26,
    height: 9,
    rx: 4.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle2",
    stroke: "#27CE0A",
    fill: "#27CE0A",
    x: 110.5,
    y: 147,
    width: 26,
    height: 9,
    rx: 4.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.248862,141.595599 L169.440061,141.595599 L169.440061,134.630501 C169.440061,118.037178 155.919575,104.721548 139.531108,104.721548 L103.886191,104.721548 L103.886191,85.0553869 C103.886191,81.5728376 101.018209,78.5 97.3308042,78.5 C93.8482549,78.5 90.7754173,81.3679818 90.7754173,85.0553869 L90.7754173,104.721548 L55.1305008,104.721548 C38.5371775,104.721548 25.2215478,118.242033 25.2215478,134.630501 L25.2215478,141.595599 L16.4127466,141.595599 C7.39908953,141.595599 0.0242792109,148.97041 0.0242792109,157.984067 L0.0242792109,180.927921 C0.0242792109,189.941578 7.39908953,197.316388 16.4127466,197.316388 L25.2215478,197.316388 L25.2215478,204.281487 C25.2215478,220.87481 38.7420334,234.19044 55.1305008,234.19044 L139.531108,234.19044 C156.124431,234.19044 169.440061,220.669954 169.440061,204.281487 L169.440061,197.316388 L178.248862,197.316388 C187.262519,197.316388 194.637329,189.941578 194.637329,180.927921 L194.637329,157.984067 C194.637329,148.97041 187.262519,141.595599 178.248862,141.595599 Z M16.4127466,184.205615 C14.569044,184.205615 12.9301973,182.771624 12.9301973,180.723065 L12.9301973,157.984067 C12.9301973,156.140364 14.3641882,154.501517 16.4127466,154.501517 L25.2215478,154.501517 L25.2215478,184.205615 L16.4127466,184.205615 L16.4127466,184.205615 Z M156.534143,204.076631 C156.534143,213.5 148.954476,221.079666 139.531108,221.079666 L55.1305008,221.079666 C45.707132,221.079666 38.1274659,213.5 38.1274659,204.076631 L38.1274659,134.630501 C38.1274659,125.207132 45.707132,117.627466 55.1305008,117.627466 L139.531108,117.627466 C148.954476,117.627466 156.534143,125.207132 156.534143,134.630501 L156.534143,204.076631 L156.534143,204.076631 Z M181.731411,180.927921 C181.731411,182.771624 180.29742,184.41047 178.248862,184.41047 L169.440061,184.41047 L169.440061,154.501517 L178.248862,154.501517 C180.092564,154.501517 181.731411,155.935508 181.731411,157.984067 L181.731411,180.927921 Z",
    id: "Shape",
    fill: "#27CE0A",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.236,2.0812592 C197.47047,2.0812592 170,25.9755464 170,55.3456928 C170,66.5967872 173.98034,77.3498288 181.512368,86.4467768 C183.40388,88.7288384 184.18634,89.500412 184.382295,89.68412 C185.639674,90.854408 186.350012,93.0221624 186.197602,93.8590544 L182.338374,115.015412 C181.814466,117.878535 182.67313,119.640771 183.485528,120.615104 C184.469386,121.793557 185.879175,122.446741 187.456342,122.446741 C188.79537,122.446741 190.175221,121.971822 191.557794,121.038313 L211.689469,107.443921 C212.284138,107.043846 213.654464,106.624719 214.920008,106.624719 C215.294228,106.624719 215.526925,106.664182 215.634428,106.688677 C215.989597,106.767603 224.418392,108.59924 231.236,108.59924 C265.00153,108.59924 292.472,84.7090352 292.472,55.3429712 C292.472,25.9755464 265.00153,2.0812592 231.236,2.0812592 Z M231.236,100.947462 C225.258006,100.947462 217.354479,99.2314928 217.276914,99.216524 C214.220557,98.5388456 209.954449,99.3811808 207.40567,101.103954 L190.586182,112.463912 L193.72963,95.2389056 C194.380093,91.6817744 192.60561,86.887676 189.641787,84.1266128 C189.615932,84.1007576 189.015819,83.5101704 187.408714,81.5696696 C181.027923,73.8620984 177.6545,64.7964488 177.6545,55.3484144 C177.6545,30.1994696 201.69031,9.73712 231.236,9.73712 C260.78169,9.73712 284.8175,30.1981088 284.8175,55.3470536 C284.8175,80.491916 260.78169,100.947462 231.236,100.947462 Z",
    id: "Message",
    stroke: "#424B50",
    strokeWidth: 3,
    fill: "#424B50",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("text", {
    id: "Hi",
    fontFamily: "RobotoSlab-Regular_Black, Roboto Slab",
    fontSize: 57.6,
    fontWeight: 800,
    letterSpacing: -1.60000008,
    fill: "#27CE0A"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 200,
    y: 77
  }, "Hi")))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGillRoyMerged);
export default __webpack_public_path__ + "static/media/Gill_roy_merged.35c11e78.svg";
export { ForwardRef as ReactComponent };